import React from 'react';

export const FeatureFlagsContext = React.createContext<{
  getBoolean: (key: string, defaultValue: boolean, callback: (value: boolean) => void) => void;
  getNumber: (key: string, defaultValue: number, callback: (value: number) => void) => void;
}>({
  getBoolean: (key: string, defaultValue: boolean, callback: (value: boolean) => void) => {
    callback(defaultValue);
  },
  getNumber: (key: string, defaultValue: number, callback: (value: number) => void) => {
    callback(defaultValue);
  },
});
